import React from "react";

const QualityStrip = () => {
  const items = [
    "FSSAI Licensed",
    "Lab-Tested Quality",
    "APEDA Registered",
    "Traceable Sourcing",
    "Custom Packaging",
    "Reliable Logistics",
    "On-Time Delivery",
    "Bespoke Specifications",
  ];
  // Duplicate for seamless marquee
  const loop = [...items, ...items];

  return (
    <section
      data-testid="quality-strip"
      className="border-y border-line bg-cream py-12 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="label-eyebrow mb-6">The Gralon Promise</div>
      </div>
      <div className="relative w-full">
        <div className="flex gap-20 animate-marquee whitespace-nowrap">
          {loop.map((c, i) => (
            <span
              key={i}
              className="font-serif italic text-3xl lg:text-5xl text-forest-dark/70"
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QualityStrip;
